import { render, staticRenderFns } from "./searchModal.vue?vue&type=template&id=60360818&scoped=true"
import script from "./searchModal.vue?vue&type=script&lang=js"
export * from "./searchModal.vue?vue&type=script&lang=js"
import style0 from "./searchModal.vue?vue&type=style&index=0&id=60360818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60360818",
  null
  
)

export default component.exports